import { Badge } from 'react-bootstrap'
import { BsCloud, BsSquare } from 'react-icons/bs'
import { MdCheck, MdChevronRight, MdClose, MdSquare } from 'react-icons/md'
import { PiChartBarThin, PiChartPieSliceThin, PiChartScatterThin, PiDotsNineLight } from 'react-icons/pi'

export default function PanelPricing() {
  return (
    <div className='container'>
      <h3 className='text-center text-muted'>تعرفه پنل ها</h3>
      <br/>
      <div className='row'>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><PiChartPieSliceThin size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>پایه</h5>
              <hr/>
              <p>۱ پنل</p>
              <p>تا ۵ کاربر</p>
            </div>
            <br/>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل مالی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل فروش
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل اداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل حسابداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل انبار
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              فضای ذخیره سازی ابری
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              دامنه اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              سرور اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              مهاجرت رایگان
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              سند اتوماتیک
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              قابلیت سفارشی سازی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پشتیبانی از طریق تیکت
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پاسخگویی ساعات اداری
            </p>
            <hr/>
            <div className='text-muted bold'>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>یک پنل</p>
                <p>رایگان</p>
              </div>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر کاربر</p>
                <p>۴۹۹ هزار تومان</p>
              </div>
            </div>
            <div className='d-flex flex-row justify-content-end align-items-center'>
              <Badge pill bg="dark">یک ماه</Badge>
            </div>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><PiChartBarThin size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>استاندارد</h5>
              <hr/>
              <p>تا ۳ پنل</p>
              <p>تا ۱۰ کاربر</p>
            </div>
            <br/>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل مالی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل فروش
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل اداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل حسابداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل انبار
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              فضای ذخیره سازی ابری
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              دامنه اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              سرور اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              مهاجرت رایگان
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              سند اتوماتیک
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              قابلیت سفارشی سازی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پشتیبانی از طریق تیکت
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پاسخگویی ساعات اداری
            </p>
            <hr/>
            <div className='text-muted bold'>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر پنل</p>
                <p>۴۹۹ هزار تومان</p>
              </div>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر کاربر</p>
                <p>۳۹۹ هزار تومان</p>
              </div>
            </div>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <Badge pill bg='primary'>هوشمند</Badge>
              <Badge pill bg="dark">یک ماه</Badge>
            </div>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><PiChartScatterThin size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>حرفه ای</h5>
              <hr/>
              <p>پنل نامحدود</p>
              <p>تا ۵۰ کاربر</p>
            </div>
            <br/>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل مالی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل فروش
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل اداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل حسابداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل انبار
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              فضای ذخیره سازی ابری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              دامنه اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              سرور اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              مهاجرت رایگان
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              سند اتوماتیک
            </p>
            <p className='bold'>
              <span className='m-2 text-secondary'><MdClose/></span>
              قابلیت سفارشی سازی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پشتیبانی گروه پیام رسان
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پاسخگویی ۲۴/۷
            </p>
            <hr/>
            <div className='text-muted bold'>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر پنل</p>
                <p>۱ میلیون و ۹۹۹ هزار تومان</p>
              </div>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر کاربر</p>
                <p>۲۹۹ هزار تومان</p>
              </div>
            </div>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <Badge pill bg='primary'>هوشمند</Badge>
              <Badge pill bg="dark">یک ماه</Badge>
            </div>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><PiDotsNineLight size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>سازمانی</h5>
              <hr/>
              <p>پنل نامحدود</p>
              <p>کاربر نامحدود</p>
            </div>
            <br/>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل مالی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل فروش
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل اداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل حسابداری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              پنل انبار
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              فضای ذخیره سازی ابری
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              دامنه اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              سرور اختصاصی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              مهاجرت رایگان
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              سند اتوماتیک
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdCheck/></span>
              قابلیت سفارشی سازی
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پشتیبانی گروه پیام رسان
            </p>
            <p className='bold'>
              <span className='m-2 text-primary'><MdSquare/></span>
              پاسخگویی ۲۴/۷
            </p>
            <hr/>
            <div className='text-muted bold'>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر پنل</p>
                <p>قراردادی</p>
              </div>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <p>هر کاربر</p>
                <p>قراردادی</p>
              </div>
            </div>
            <div className='d-flex flex-row justify-content-between align-items-center'>
              <Badge pill bg='primary'>هوشمند</Badge>
              <Badge pill bg="dark">یک ماه</Badge>
            </div>
          </div>
        </div>
      </div>
      <div className='d-flex flex-row justify-content-end'>
        <p className='text-muted'>به مبالغ فوق ۱۰ درصد مالیات بر ارزش افزوده اضافه می گردد
          <span className='m-2'><MdChevronRight/></span>
        </p>
      </div>
    </div>
  )
}
